/**
 * Created by Ivan on 10.08.2026
 */

const StickersShopWindow2 = Prefab.createWindow("stickers2_shop", "stickers2_shop_window_prefab_json", {
    theme: () => bundles.stickers2_shop.jsons.stickers2_shop_theme_json
});
